var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350 500",
    style: {
      enableBackground: "new 0 0 350 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A7A7A7;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pin_sharp_circle-_624_",
    className: "st0",
    d: "M224.5,181.2c0,27.3-22.2,49.5-49.5,49.5s-49.5-22.2-49.5-49.5 s22.2-49.5,49.5-49.5S224.5,153.8,224.5,181.2 M175,423.3c0,0-123.8-173.3-123.8-247.5C51.3,107.4,106.7,52,175,52 s123.8,55.4,123.8,123.8C298.8,250,175,423.3,175,423.3 M175,2.5C79.3,2.5,1.8,80.1,1.8,175.8C1.8,271.4,175,497.5,175,497.5 s173.3-226.1,173.3-321.8C348.3,80.1,270.7,2.5,175,2.5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.7b29e9dcf0d57159ec80862729030d8f.svg";
export { ForwardRef as ReactComponent };